<ng-template #smsModal let-modal>
    <div class="modal-header" style="background-color: transparent; border-bottom: none;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="d-flex flex-column justify-content-center text-center " style="padding: 30px 64px 64px 64px">
        <p class="title-modal">Envoyez par SMS</p>
        <p class="text-modal">
            Envoyez ce message directement par SMS.
        </p>

        <div >
            <div class="d-flex p-0" style="margin-bottom: 24px">
                <img src="assets/images/logo/logo.png" style="width: 27px; height: 24px;margin-right: 8px">
                <p class="titrPhone m-0">25 255 236</p>
            </div>

            <div class="container-blue">
                <p class="texteSms">Cher client,Le solde de votre facture impayée <b>N° CDC-000001</b> du <b>15/04/2025</b> est de <b>300,600TND</b>. Prière de procéder au paiement.</p>
            </div>
        </div>











        <div class="modal-footer p-0" style="justify-content: center; gap: 16px; border-top: none;">
            <button
                    type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px;"
            >
                Envoyer
            </button>
            <button
                    type="button"
                    class="btn d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px; background-color: rgba(128, 131, 144, 0.16);"
                    (click)="modal.dismiss('Cancel click')"
            >
                Annuler
            </button>
        </div>
    </div>
</ng-template>
